import styled from '@emotion/styled';
import aircash from 'src/assets/images/paymentMethods/Aircash.png';
import dinersclub from 'src/assets/images/paymentMethods/DinersClub.png';
import kekspay from 'src/assets/images/paymentMethods/KeksPay.png';
import maestro from 'src/assets/images/paymentMethods/Maestro.png';
import mastercard from 'src/assets/images/paymentMethods/Mastercard.png';
import visa from 'src/assets/images/paymentMethods/Visa.png';
import { mediaQuery } from 'src/common';
import { Flex } from '../grid';


const ImageStyle = styled.img({
  maxHeight: '28px',

  [mediaQuery('mobile')]: {
    maxHeight: '34px',
  },
});


export const PaymentMethods = () => (
  <Flex gap={16} wrap='wrap'>
    <ImageStyle src={visa} alt="Visa" />
    <ImageStyle src={dinersclub} alt="Diners Club" />
    <ImageStyle src={mastercard} alt="Mastercard" />
    <ImageStyle src={maestro} alt="Maestro" />
    <ImageStyle src={aircash} alt="Aircash" />
    <ImageStyle src={kekspay} alt="KEKS Pay" />
  </Flex>
);
